<template>
  <div :class="$style.wrapper">
    <span :class="$style.text">{{ text }}</span>
  </div>
</template>

<script>
export default {
  props: ["text"],
  data() {
    return {};
  },
  methods: {}
};
</script>

<style lang='scss' module>
@import "../assets/css/globals.scss";

.wrapper {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;

  border: 2px solid #616161;

  height: 44px;

  padding-left: 25px;
  padding-right: 25px;

  border-radius: 30px;

  color: #616161;

  font-weight: bold;
  font-size: 13px;

  cursor: pointer;

  &:before {
    position: absolute;
    z-index: 0;
    top: 50%;
    left: 100%;
    margin: -15px 0 0 1px;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background-color: rgba(#616161, 0.3);
    transform-origin: 100% 50%;
    transition: transform 0.3s, opacity 0.3s;
    content: "";
  }

  &:hover,
  &:focus {
    &:before {
      transform: scale3d(12, 12, 1);
    }
  }
}
.text {
  position: relative;
  z-index: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/HollowButton.vue